import { useRef } from 'react'
import { DAY_CELL_W } from '../constants'
import { DateTime } from 'luxon'
// Constants
const NUM_DAY_PADDING = 2
const NUM_DAY_START_PADDING = 1

// Types
interface GridPositionInfo {
    numDisplayDays: number
    numProjectDays: number
    numStartPaddingDays: number
}

interface DateInfo {
    displayStart: DateTime
}

/**
 * Hook to manage calendar grid calculations and positioning
 * @param startDate Project start date
 * @param endDate Project end date
 */
export const useCalendarGrid = (startDate: DateTime, endDate: DateTime) => {
    const gridRef = useRef<HTMLDivElement>(null)

    const getProjectDurationDays = () => {
        return endDate.diff(startDate, 'days').days
    }

    const gridStart = startDate.minus({ days: NUM_DAY_START_PADDING })
    const numProjectDays = getProjectDurationDays()
    const numDisplayDays = numProjectDays + NUM_DAY_PADDING

    // Position calculations
    const getDateGridPosition = (end: DateTime) => {
        return end.diff(gridStart, 'days').days
    }

    const convertGridPositionToDate = (gridPos: number) => {
        const adjustedDate = gridStart.plus({ days: gridPos })
        return adjustedDate
    }

    const getClickedGridPosition = (clickX: number) => {
        if (!gridRef.current) return 0

        const gridEl = gridRef.current.getBoundingClientRect()
        const clickXCoord = clickX - gridEl.x + gridRef.current.scrollLeft
        return Math.floor(clickXCoord / DAY_CELL_W)
    }

    return {
        gridRef,
        getDateGridPosition,
        getClickedGridPosition,
        convertGridPositionToDate,
        gridPositionInfo: {
            numDisplayDays,
            numProjectDays,
            numStartPaddingDays: NUM_DAY_START_PADDING,
        } as GridPositionInfo,
        dateInfo: {
            displayStart: gridStart,
        } as DateInfo,
    }
}

export type CalendarGridController = ReturnType<typeof useCalendarGrid>
